import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import {
  ButtonMob,
  instance,
  laptop1350,
  laptop1600,
  ModalInfoComponent,
} from "../../../../utils/utils";
import "../../athlete.css";
import ModalInfo from "../modal-info";
import { useNavigate, useParams } from "react-router-dom";
import PreValuationSteps from "../pre-valuations-step";
import ModalInfoPreValuations from "../modal-info-pre-valuations";
import {
  CustomProvider,
  DateRangePicker,
  Stack,
  Tooltip,
  Whisper,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import ConfirmDeletionModal from "../../../Mob/components/modal-delete";

const Step7Test = ({ userDetail, setFormData }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const testPhysical = [
    {
      id: 1,
      name: "¿Cuántas repeticiones de Push Ups pudo hacer el cliente en un minuto?",
      value: userDetail?.physic_test?.max_pushups || 0, // Default value if not provided
      label: "max_pushups",
    },
    {
      id: 2,
      name: "¿Cuántas repeticiones de burpees pudo hacer el cliente en un minuto?",
      value: userDetail?.physic_test?.max_burpees || 0,
      label: "max_burpees",
    },
    {
      id: 3,
      name: "¿Cuantos segundos pudo sostener el cliente la sentadilla isometrica?",
      value: userDetail?.physic_test?.max_isometric_squat || 0,
      label: "max_isometric_squat",
    },
    {
      id: 4,
      name: "¿Cuantos segundos pudo sostener el cliente la plancha en antebrazos?",
      value: userDetail?.physic_test?.max_plank_forearm || 0,
      label: "max_plank_forearm",
    },
    {
      id: 5,
      name: "¿Cuantos segundos pudo sostener el cliente la plancha en palmas?",
      value: userDetail?.physic_test?.max_plank_palms || 0,
      label: "max_plank_palms",
    },
    {
      id: 6,
      name: "¿Cuantas repeticiones de Crunch pudo hacer el cliente en un minuto?",
      value: userDetail?.physic_test?.max_situps || 0,
      label: "max_situps",
    },
    {
      id: 7,
      name: "¿Cuantas repeticiones de sentadilla pudo hacer el cliente en un minuto?",
      value: userDetail?.physic_test?.max_squat || 0,
      label: "max_squat",
    },
    {
      id: 8,
      name: "¿Cuantas repeticiones de Superman pudo hacer el cliente en un minuto?",
      value: userDetail?.physic_test?.max_trunk_extension || 0,
      label: "max_trunk_extension",
    },
  ];
  const [modal, setModal] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [loading, setLoading] = useState(false);

  function handleAction() {
    let data = { ...userDetail, customer_id: Number(id) };
    instance
      .post(`customers/corp/medical/evaluation/create`, data)
      .then((res) => res.data)
      .then((data) => {
        setLoading(false);
        navigate(`/athlete-objectives/${id}`);
      })
      .catch((err) => {
        setModalError(
          <ConfirmDeletionModal
            zIndex={1000}
            onCancel={() => {
              setModalError(null);
              setModal(null);
            }}
            onConfirm={() => {
              setModalError(null);
              setModal(null);
            }}
            loader={false}
          >
            <PerfectScrollbar style={{ maxHeight: "5vh" }}>
              {err.response?.data?.error ||
                err.response?.data ||
                "Error al obtener la información del atleta."}
            </PerfectScrollbar>
          </ConfirmDeletionModal>
        );
      });
  }

  function handleModal() {
    setModal(
      <ModalInfo
        onCancel={() => setModal(null)}
        buttonConfirmText="Guardar y continuar"
        buttonConfirm={true}
        buttonCancelText="Cancelar"
        buttonsWidth="80%"
        maxWidth="30rem"
        onConfirm={handleAction}
        loader={false}
      >
        <div>
          <span>¿Desea guardar la valoración del usuario?</span>
        </div>
      </ModalInfo>
    );
  }

  const tooltip = (
    <Tooltip>
      <div className="p-2 input-tooltip-valoration">
        <div className="pb-1">
          <span className="input-tooltip-valoration ">
            <strong>¿Por qué es importante este test físico?</strong>
          </span>
        </div>
        <p>
          Este paso es obligatorio para completar la valoración y control del
          atleta. Nos permite establecer un nivel estimado de condición física y
          ubicar al usuario dentro del ranking interno de tu gimnasio y de la
          comunidad Eleva. Además, estos datos son clave para ver y hacer
          seguimiento real a su progreso. Ya que en nuestra plataforma hay 3
          niveles: Principiantes, Intermedio y Avanzado.
          <br />
        </p>
      </div>
    </Tooltip>
  );
  return (
    <div className="d-flex flex-column col-3 px-2 h-100 w-100">
      {modal}
      {modalError}
      {/* Parte 1: Test físicos */}
      <div className="d-flex justify-content-start">
        <Whisper key={"per"} trigger="hover" placement="top" speaker={tooltip}>
          <span
            className="label-step cursor-pointer"
            style={{ color: "rgb(49, 119, 190)" }}
          >
            <strong>7. Test físicos ¿Por qué es importante?</strong>{" "}
            <i class="bi bi-question-circle-fill"></i>
          </span>
        </Whisper>
      </div>

      <div className="pt-2 d-flex flex-column gap-2" style={{ height: "94%" }}>
        <div style={{ height: laptop1350.matches ? "40%" : "35%" }}>
          <div className="d-flex justify-content-center gap-3 align-items-center py-1">
            <div className="d-flex w-100" id="location-select"></div>
          </div>
          {/* Parte 2: Prueba de recuperación */}
          <div className="step3-card px-4 flex-grow-1 d-flex flex-column justify-content-center align-items-center h-100">
            <PerfectScrollbar className="w-100 d-flex flex-column align-items-center">
              {testPhysical.map((item, index) => {
                return (
                  <div key={index} className="d-flex gap-2 flex-column">
                    <span className="label-step ">
                      <strong>{item.name}</strong>
                    </span>
                    <input
                      placeholder={item.value}
                      type="number"
                      className="input_info_athlete_input p-2 w-50 mx-auto mb-2"
                      style={{
                        border: "1px solid #b6c1ce",
                        borderRadius: "20px",
                        textAlign: "center",
                      }}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          physic_test: {
                            ...prev.physic_test,
                            [item.label]: Number(e.target.value),
                          },
                        }));
                      }}
                    />
                  </div>
                );
              })}
            </PerfectScrollbar>
          </div>
        </div>
        <div style={{ height: laptop1350.matches ? "35%" : "30%" }}>
          <div className="d-flex justify-content-start mt-2 ">
            <span className="label-step">
              <strong>8. Observaciones y complementarios</strong>
            </span>
          </div>

          <div className=" d-flex flex-column gap-2 h-100">
            <div className="d-flex justify-content-center gap-3 align-items-center">
              <div className="d-flex w-100" id="location-select"></div>
            </div>
            {/* Parte 2: Observaciones y complementarios */}
            <div className="step3-card py-1 px-4 flex-grow-1 d-flex flex-column align-items-center">
              <div className="flex-grow-1 px-1 step3-card-text w-100 h-100">
                <textarea
                  className="input_info_athlete_input w-100  h-100"
                  defaultValue={userDetail?.observations || ""}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      observations: e.target.value,
                    }));
                  }}
                  placeholder="Ingresar observaciones"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-flex justify-content-center gap-2 w-70 mx-auto mt-2 mt-xxl-3"
          style={{ height: laptop1350.matches ? "10%" : "15%" }}
        >
          <ButtonMob
            handleClick={handleModal}
            colorButton={"var(--elevvabutonLogin_User)"}
            text={"Guardar  y definir objetivos "}
            className={"px-3 h-100"}
            sizeFont=" calc(0.3rem + 0.3vw)"
          />
        </div>
      </div>
    </div>
  );
};

export default Step7Test;
